
type Props = {
    active: boolean,
    label: string,
    onClick: (label: string) => void
}

export function TabNav({ active, label, onClick }: Props) {
    return <li className="nav-item" role="presentation">
        <button
            onClick={() => onClick(label)}
            className={`${active && "active"} nav-link relative flex items-center whitespace-nowrap py-3 px-6 text-jacarta-400 hover:text-jacarta-700 dark:hover:text-white`}
            id="on-sale-tab">
            <span className="font-display text-base font-medium">{label}</span>
        </button>
    </li>
}